<div class="container-fluid">
  <div class="page-title flex">
    <h5 class="float-left">{{'Connected Device' | translate}}</h5>
    <div>
      <button pButton type="button" label="{{'Add Device' | translate}}" icon="fa fa-plus" class="ui-button-danger update" (click)="showDialog()" *ngIf="IsSuperAdmin || editProAuth"></button>
      <button pButton type="button" label="{{'Edit' | translate}}" icon="fa fa-pencil-square-o" [disabled]="(selectedNode == null)" class="ui-button-danger update"
      (click)="showEditDialog()"  *ngIf="IsSuperAdmin || editProAuth"></button>
      <button pButton type="button" label="{{'Delete' | translate}}" icon="fa fa-trash" class="ui-button-danger" (click)="showConfirmDialog()" [disabled]="(selectedNode == null)" *ngIf="IsSuperAdmin || editProAuth"></button>
    </div>
  </div>
  <div class="page-filter clearfix two-filter">
    <div class="filter-flex">
      <div class="filter">
        <div class="filter-list">
          <div class="filter-content">
            <p-select [options]="gatewayOptions" [(ngModel)]="selectedGateway" [style]="{'width':'100%'}" placeholder="{{'Select Gateway' | translate}}"
            (onChange)="dispatchGatewayFilter();">
              <ng-template pTemplate="item" let-item>
                {{item.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item.label | translate}}
              </ng-template>
            </p-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-table class="deviceTable pageAllOptions" [columns]="connectionDevice_cols" [value]="connectionDevice" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]"
    [scrollable]="true" selectionMode="single" [(selection)]="selectedNode" >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th [hidden]="col.hide" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td [hidden]="col.hide" *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{rowData[col.field]}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="connectionDevice_cols.length">
          <div translate class="ui-emptymessage">No Data found</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>


<!-- Add/Edit -->
<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="displayDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="gatewayDialog">
  <div class="dialog-content">
    <p-steps [(activeIndex)]="tabIndex" [readonly]="true"></p-steps>
    <section *ngIf="tabIndex === 0">
      <div class="form-group" *ngIf="isMsp">
        <label translate>Company</label>
        <div class="select">
          <p-select [options]="companyOptions" [(ngModel)]="dialogInput.company" [style]="{'width':'100%'}" (onChange)="dailogFilter(true);">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>Gateway</label>
        <div class="select">
          <p-select [options]="dailogGatewayOptions" [(ngModel)]="dialogInput.gateway" [style]="{'width':'100%'}" [disabled]="disableGateWayFlag">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>IP address</label>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="dialogInput.ipAddress"  pInputText
        pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$">
      </div>
      <div class="form-group">
        <label translate>SNMP Profile</label>
        <div class="select">
          <p-select [options]="profileOptions" [(ngModel)]="dialogInput.SNMPProfile" [style]="{'width':'100%'}" [disabled]="disableProfileFlag" appendTo="body">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
    </section>
    <section *ngIf="tabIndex === 1">
      <div class="loading">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        <p><span translate>Please wait</span> ...</p>
      </div>
    </section>
    <section *ngIf="tabIndex === 2">
      <div class="form-group">
        <label translate>Model Name</label>
        <input type="text" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.deviceModel" [disabled]="true">
      </div>
      <div class="form-group">
        <label translate>IP address</label>
        <input type="text" size="30" class="form-control pInputText" [(ngModel)]="dialogInput.ipAddress" pInputText [disabled]="true">
      </div>
      <div class="form-group">
        <label translate>Device Name</label>
        <input type="text" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.device">
      </div>
    </section>
    <section *ngIf="tabIndex === 3" class="failMsg">
      <div class="icon">
        <i class="fa fa-check-circle normal"></i>
      </div>
      <div class="content-info">
        <h5 translate>The discovery process is complete.</h5>
        <p translate>No devices were found</p>
      </div>
    </section>
    <section *ngIf="tabIndex === 4" class="failMsg">
      <div class="icon">
        <i class="fa fa-times-circle critical"></i>
      </div>
      <div class="content-info">
        <h5 translate>Discovery process failed.</h5>
        <p translate>Please check the configuration and make sure the PPC gateway is online.</p>
      </div>
    </section>
    <section *ngIf="tabIndex === 5" class="failMsg">
      <div class="icon">
        <i class="fa fa-times-circle critical"></i>
      </div>
      <div class="content-info">
        <h5 translate>The discovery process is complete.</h5>
        <p translate>The device already exists in the PowerPanel Cloud.</p>
      </div>
    </section>
  </div>
  <ng-template #footer>
    <section *ngIf="tabIndex === 0" class="grid">
      <button type="button" pButton (click)="checkGateway();" label="{{'Continue' | translate}}" class="ui-button-danger"
      [disabled]="!dialogInput.gateway || dialogInput.gateway === '0' || !dialogInput.ipAddress ||
      !ipAddressPattern.test(dialogInput.ipAddress) || !dialogInput.SNMPProfile || dialogInput.SNMPProfile === '0' ||
      (isMsp && (!dialogInput.company || dialogInput.company === '0')) || disableGateWayFlag || disableProfileFlag"></button>
      <button type="button" pButton (click)="displayDialog=false; stopInterval(); stopDiscoveryJob();" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="tabIndex === 1" class="flex">
      <button type="button" pButton (click)="displayDialog=false; stopInterval(); stopDiscoveryJob();" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="tabIndex === 2" class="grid">
      <div *ngIf="dialogInput.UpdateType === 'Add Device'" class="flex">
        <button type="button" pButton (click)="addDevice();" label="{{'Add' | translate}}" class="ui-button-danger" [disabled]="!dialogInput.device"></button>
        <button type="button" pButton (click)="this.tabIndex = 0;" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
      </div>
      <div *ngIf="dialogInput.UpdateType === 'Edit Device'" class="flex">
        <button type="button" pButton (click)="saveDevice();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="!dialogInput.device"></button>
        <button type="button" pButton (click)="displayDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
      </div>
    </section>
    <section *ngIf="tabIndex === 3 || tabIndex === 4 || tabIndex === 5" class="flex">
      <button type="button" pButton (click)="displayDialog=false; stopInterval();" label="{{'OK' | translate}}" class="ui-button-danger"></button>
    </section>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="deleteDevice()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<p-toast [style]="{marginTop: '70px'}"></p-toast>
<app-dialog></app-dialog>
